<section class="addDoner mt-4">
  <div class="card-2026">
    <h2 class="card-2026__title">{{ addDoner }}</h2>

    <form
      novalidate
      [formGroup]="addDonerForm"
      (ngSubmit)="saveDoner()"
      class="space-y-5"
      autocomplete="off"
    >
      <div class="form-row-2026">
        <label class="form-row-2026__label" for="addDonerFullName">שם מלא</label>
        <input
          id="addDonerFullName"
          type="text"
          placeholder="ישראל ישראלי"
          class="input-2026"
          formControlName="fullName"
          name="fullName"
        />
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div class="form-row-2026">
          <app-money-input
            formControlName="amountDonated"
            label="סכום (₪)"
          ></app-money-input>
        </div>

        <div class="form-row-2026">
          <label class="form-row-2026__label" for="addDonerContact">יצירת קשר</label>
          <input
            id="addDonerContact"
            type="tel"
            inputmode="tel"
            placeholder="050-555-0000"
            class="input-2026"
            formControlName="contact"
            name="contact"
          />
        </div>
      </div>

      <div class="pt-2 flex justify-end">
        <button
          type="submit"
          class="btn-2026--primary w-full md:w-auto md:min-w-[200px]"
          [disabled]="loading || addDonerForm.invalid"
        >
          <span *ngIf="!loading" class="flex items-center gap-2">
            <i class="material-symbols-outlined" aria-hidden="true">add_circle</i>
            {{ add }}
          </span>
          <span *ngIf="loading" class="flex items-center gap-2">
            <mat-spinner diameter="22"></mat-spinner>
            <span>שומר...</span>
          </span>
        </button>
      </div>
    </form>
  </div>
</section>
